<template>
  <div class="finance_box" ref="myElementRef">
    <div ref="searchBox">
      <hc-search :data="serchData" @serch="getSarch($event)" @getadd="getadd($event)" />
    </div>
    <!-- 表格 -->
    <div class="table_box">
      <hc-table :tableData="tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage"
        @pageChange="pageChange" @limitChange="limitChange">
        <template #status="{ row }">
          {{ row.status == 1 ? '启用' : '不启用' }}
        </template>
        <template #operation="scope">
          <el-button size="small" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" link @click="del(scope.row)">删除</el-button>
        </template>
      </hc-table>
    </div>
    <!-- 新增 -->
    <el-dialog align-center v-model="dialogVisible" :title="state.title" width="30%" draggable>
      <div class="from_add">
        <el-form style="width: 90%" label-width="100px" :model="formLabelAlign" ref="formRef" :rules="rules">
          <el-form-item label="部门编码" prop="departmentCode">
            <el-input v-model="formLabelAlign.departmentCode" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="部门名称" prop="departmentName">
            <el-input v-model="formLabelAlign.departmentName" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="排序顺序">
            <el-input v-model="formLabelAlign.sortOrder" placeholder="请输入" type="number" />
          </el-form-item>

          <el-form-item label="状态">
            <el-select v-model="formLabelAlign.status" class="m-2" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="部门描述">
            <el-input class="text_input" v-model="formLabelAlign.description" type="textarea" :rows="4"
              placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>


      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="subimt($refs.formRef)"> 确认 </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { DepartmentsAdd, DepartmentsUpdate, DepartmentsDel, DepartmentsList } from '@/api/departments.js';
const myElementRef = ref();
const searchBox = ref();
const dialogVisible = ref(false);
const options = reactive([
  { label: "不启用", value: 0 },
  { label: "启用", value: 1 },
])
let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const rules = reactive({
  departmentName: [
    {
      required: true,
      message: "部门编号不能为空",
      trigger: "blur",
    },
  ],
  departmentCode: [
    {
      required: true,
      message: "部门名称不能为空",
      trigger: "blur",
    },
  ],
});
const formLabelAlign = reactive({
  departmentName: "",
  departmentCode: "",
  description: "",
  sortOrder: 0,
  status: 1
});
const tableData = ref([]);

const serchData = reactive([
  {
    label: "部门名称",
    type: "input",
    value: "",
  },

  {
    label: "",
    type: "add",
    value: true
  }

]);

const state = reactive({
  dialogShow: true,
  title: "编辑部门信息",
  column: [
    {
      type: "index",
      show: true,
      label: "序号",
      width: 80,
    },
    {
      prop: "department_code",
      show: true,
      label: "部门编码",
      width: 200,
    },
    {
      prop: "department_name",
      show: true,
      label: "部门名称",
      width: 300,
    },
    {
      prop: "description",
      show: true,
      label: "部门描述",
    },
    {
      prop: "sort_order",
      show: true,
      label: "排序顺序",
      width: 100,
    },
    {
      prop: "status",
      show: true,
      label: "状态",
      width: 140,
    },
    {
      prop: "created_at",
      show: true,
      label: "创建时间",
      width: 160,
    },
    {
      prop: "operation",
      show: true,
      width: 200,
      label: "操作",
    },
  ],
  flng: true,
  offsetHeight: 0,
  tableHeader: [],
});

onMounted(() => {
  try {
    nextTick(() => {
      offHeighths();
    });
    window.onresize = () => {
      nextTick(() => {
        offHeighths();
      });
    };
    tableHeaderFn();
  } catch { }

  getList();
});
// 动态改变表头
const change = (item) => {
  tableHeaderFn();
};

// 删除
const del = (row) => {
  ElMessageBox.alert('确认要删除部门信息吗', '删除提醒', {
    confirmButtonText: '确认',
    callback: (action) => {
      if (action == "confirm") {
        // console.log(111)
        getDel(row)
      }
      
    },
  })
};

const getDel = async (row) => {
  // console.log(serchData[0].value)
  const res = await DepartmentsDel({
    departmentId: row.department_id
  });
  if (res.code === 200) {
    // dialogVisible.value = false;
    ElMessage.success('删除成功');
  } else {
    ElMessage.error(res.msg || '删除失败');
  }
  getList()
};

// 编辑
const edit = (row) => {
  // console.log(row)
  Object.assign(formLabelAlign, {
    departmentId: row.department_id,
    departmentName: row.department_name,
    departmentCode: row.department_code,
    description: row.description,
    sortOrder: row.sort_order,
    status: row.status,
  })
  dialogVisible.value = true;
};

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 130 - searchBox.value?.offsetHeight;
  }
};

onUnmounted(() => {
  window.onresize = null;
});

// 查询过来的数据
const getSarch = (data) => {
  // console.log("查询", data);
  page.value = 1
  getList()
};

const getadd = () => {
  // console.log("新增");
  Object.assign(formLabelAlign, {
    departmentName: "",
    departmentCode: "",
    description: "",
    sortOrder: 0,
    status: 1,
    departmentId:null
  })
  dialogVisible.value = true
};

// 表头筛选
const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) {
      return v.show == true;
    } else {
      v.show = false;
    }
  });
};


const pageChange = (currentPage) => {
  // console.log(currentPage, "0002")
  page.value = currentPage;
  // getSearch(searchData)
  getList();
}

const limitChange = (currentLimit) => {
  // console.log(currentLimit, "0001")
  page.value = 0;
  limit.value = currentLimit;
  getList();
}

const getList = async () => {
  // console.log(serchData[0].value)
  const res = await DepartmentsList({
    page: page.value,
    limit: limit.value,
    department_name: serchData[0].value
  });
  tableData.value = res.data || [];
  maxPage.value = res?.maxPage || 0;
};

const subimt = async (formEl) => {
  if (!formEl) return;

  await formEl.validate(async (valid) => {
    if (valid) {
      try {
        const data = { ...formLabelAlign };
        // console.log(data)
        if (data.departmentId > 0) {
          const res = await DepartmentsUpdate(data);
          if (res.code === 200) {
            dialogVisible.value = false;
            ElMessage.success('修改成功');
          } else {
            ElMessage.error(res.msg || '修改失败');
          }
        } else {
          const res = await DepartmentsAdd(data);
          if (res.code === 200) {
            dialogVisible.value = false;
            ElMessage.success('保存成功');
          } else {
            ElMessage.error(res.msg || '保存失败');
          }
        }
        getList()

      } catch (error) {
        ElMessage.error('保存失败，请重试');
      } finally {

      }
    } else {
      ElMessage.warning('请填写完整的信息');
    }
  });
};

</script>

<style lang="less" scoped>
.finance_box {
  flex: 1;
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}

.btn_box {
  height: 40px;
  display: flex;
}

.table_box {
  width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
  background-color: #1e6aed;
  border: none;
}

.serBtn {
  margin-left: 10px;
  background-color: #f0f0f0;
  color: #000;
  border: none;
}

.serBtn:hover {
  background-color: #f0f0f0;
  color: #000;
}

.from_add {
  display: flex;
  width: 100%;
  justify-content: center;
}

.tree_itme {
  min-height: 400px;
}
</style>
